.signet-accordion {
  display: block;

  .accordion-slide {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 5px;
    text-transform: none !important;

    &:first-child {
      margin-top: 0;

      .accordion-heading {
        margin: 0;

        .accordion-control {
          border-bottom: 0;
          background: var(--pure-white);
          text-transform: none;

          &[aria-expanded='false'] {
            border-radius: 4px;
            border: 1px solid var(--gray-200);
          }

          &[aria-expanded='true'] {
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
            border-top: 1px solid var(--gray-200);
            border-left: 1px solid var(--gray-200);
            border-right: 1px solid var(--gray-200);
          }
        }
      }
    }

    &:last-child {
      .accordion-heading {
        .accordion-control {
          text-transform: none;
          background: var(--pure-white);

          &[aria-expanded='false'] {
            transition-delay: 0.5s;
            transition-property: border-radius;
          }
        }
      }

      .accordion-start {
        display: flex;
        align-items: start;

        .heading-start {
          display: flex;
          flex-direction: column;
          align-items: start;

          .sub-heading-html-content {
            margin-top: 12px !important;
          }
        }

        .pending-icon {
          margin-right: 8px;
          color: black;
          opacity: 67%;
        }

        .completed-icon {
          margin-right: 8px;
          color: #006137;
        }
      }

      .accordion-content {
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-left: 1px solid var(--gray-200);
        border-right: 1px solid var(--gray-200);
        border-bottom: 1px solid var(--gray-200);
      }
    }

    .accordion-heading {
      .accordion-control {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-weight: bold;
        color: var(--text-primary);
        font-size: 14px;
        padding-left: 14px !important;
        padding-right: 14px !important;
        background-color: var(--gray-100);
        text-transform: none !important;
        text-align: left !important;

        .html-with-icon {
          display: flex;
        }

        .accordion-html-content {
          display: block;
          margin-right: 12px;
        }

        .accordion-icon-container {
          width: 30px;
          height: 30px;
          // background-color: rgba($color: #000000, $alpha: 0.1);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
        }

        .accordion-icon {
          color: var(--text-primary);
          transition: all 0.3s ease-in-out;
          line-height: 0 !important;
        }

        &[aria-expanded='true'] {
          .accordion-icon {
            transform: rotate(180deg);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }

    .accordion-content {
      max-height: 0;
      overflow: hidden;
      visibility: hidden;
      transition: all 0.3s ease-in-out;
      background-color: var(--pure-white);
      padding: 0 14px !important;

      &[aria-hidden='false'] {
        visibility: visible;
        margin-bottom: 16px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        // padding-top: 12px !important;
        padding-bottom: 12px !important;
      }
    }
  }

  .borderless.accordion-slide {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 5px;
    text-transform: none !important;

    &:first-child {
      margin-top: 0;

      .accordion-heading {
        margin: 0;

        .accordion-control {
          border-bottom: 0;
          background: var(--pure-white);
          text-transform: none;

          &[aria-expanded='false'] {
            border-radius: 4px;
            border: none;
          }

          &[aria-expanded='true'] {
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
            border-top: none;
            border-left: none;
            border-right: none;
          }
        }
      }
    }

    &:last-child {
      .accordion-heading {
        .accordion-control {
          text-transform: none;
          background: var(--pure-white);

          &[aria-expanded='false'] {
            transition-delay: 0.5s;
            transition-property: border-radius;
          }
        }
      }

      .accordion-start {
        display: flex;
        align-items: start;

        .pending-icon {
          margin-right: 5px;
          color: black;
          opacity: 67%;
        }

        .completed-icon {
          margin-right: 5px;
          color: #006137;
        }
      }

      .accordion-content {
        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-left: none;
        border-right: none;
        border-bottom: none;
      }
    }

    .accordion-heading {
      .accordion-control {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        font-weight: bold;
        color: var(--text-primary);
        font-size: 14px;
        padding-left: 14px !important;
        padding-right: 14px !important;
        background-color: var(--gray-100);
        text-transform: none;

        .html-with-icon {
          display: flex;
        }

        .accordion-html-content {
          display: block;
          margin-right: 12px;
        }

        .accordion-icon {
          color: var(--text-primary);
          transition: all 0.3s ease-in-out;
        }

        &[aria-expanded='true'] {
          .accordion-icon {
            transform: rotate(180deg);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }

    .accordion-content {
      max-height: 0;
      overflow: hidden;
      visibility: hidden;
      transition: all 0.3s ease-in-out;
      background-color: var(--pure-white);
      padding: 0 14px !important;

      &[aria-hidden='false'] {
        visibility: visible;
        margin-bottom: 16px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
        padding-top: 12px !important;
        padding-bottom: 12px !important;
      }
    }
  }

  .is-child.accordion-slide {
    padding-left: 26px;

    .accordion-content {
      max-height: 0;
      overflow: hidden;
      visibility: hidden;
      transition: all 0.3s ease-in-out;
      background-color: var(--pure-white);
      padding: 0 14px !important;

      &[aria-hidden='false'] {
        visibility: visible;
        padding-top: 12px !important;
        padding-bottom: 12px !important;
      }
      &:last-child {
        &::after {
          left: 0px;
          bottom: 0;
        }
      }
    }

  }

  .child-trailing-line.accordion-slide {
    position: relative;
    .accordion-heading {
      position: relative;

      &::before {
        content: '';
        position: absolute;
        left: -15px;
        top: 25px;
        width: 15px;
        height: 1px;
        background: var(--gray-200);
      }

      // &::after {
      //   content: '';
      //   position: absolute;
      //   left: -15px;
      //   bottom: 55%;
      //   width: 1px;
      //   height: 100%;
      //   background: var(--gray-200);
      //   z-index: 0;
      // }
    }
    &::after {
      content: '';
      position: absolute;
      left: 11px;
      bottom: 0;
      width: 1px;
      height: 110%;
      background: var(--gray-200);
      z-index: 0;
    }
  }

  .parent-trailing-line.accordion-slide {
    .accordion-control {
      &[aria-expanded='true'] {
        .accordion-start {
          position: relative;

          &::before {
            content: "";
            position: absolute;
            height: 140%;
            left: 11px;
            top: 18px;
            width: 1px;
            background-color: var(--gray-200);
          }
        }
      }
    }
    .accordion-control.is-child {
      .accordion-start {
        position: relative;

        &::before {
          content: '';
          position: absolute;
          background-color: transparent !important;
        }
      }
    }
  }

  &.sm {
    .accordion-slide {
      .accordion-heading {
        .accordion-control {
          padding: 8px 0;
        }
      }
    }
  }

  &.md {
    .accordion-slide {
      .accordion-heading {
        .accordion-control {
          padding: 16px 0;
        }
      }
    }
  }

  &.lg {
    .accordion-slide {
      .accordion-heading {
        .accordion-control {
          padding: 16px 0;
        }
      }
    }
  }
}

.accordion-content .signet-accordion:last-child .accordion-slide.is-child:after {
  bottom: unset;
  top: -7px;
  height: 57%;
}